import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import PaymentProfileIcon from '../paymentus/payment-profile-icon';
import { makeStyles } from '@material-ui/core/styles';
import {
  AccountDetail,
  AccountType,
  PaymentCategory,
} from '../../__generated__/pge-types';
import ROUTES from '../../routes';
import { isIphoneChrome } from '../../util/mobile/iphoneBrowser-validate';
import { useIsApplePayEnabled } from '../../hooks/useIsApplePayEnabled';

type Props = {
  labelComponent?: any;
  accountType?: AccountDetail;
};

const useStyledMenuStyles = makeStyles(() => ({
  iconMargin: {
    ['@media not all and (min-resolution:.001dpcm)']: {
      ['@supports (-webkit-appearance:none) and (stroke-color:transparent)']: {
        margin: '0px !important',
      },
    },
  },
}));

export default function PaymentMethodTypeIconList(props: Props) {
  const isApplePayEnabled = useIsApplePayEnabled();
  const types = [
    'PAYPAL_ACCOUNT',
    ...(isApplePayEnabled ? ['AP'] : []),
    ...(!isIphoneChrome() ? [PaymentCategory.Venmo] : []),
  ];
  const classes = useStyledMenuStyles();
  const currentPath = location.pathname;

  return (
    <>
      <Grid
        container
        direction="row"
        spacing={1}
        alignItems="center"
        className={classes.iconMargin}
        style={{ marginTop: '0px' }}
      >
        <Grid item>{props.labelComponent}</Grid>
        <Grid
          item
          container
          direction={'row'}
          spacing={1}
          style={{ width: 'auto' }}
        >
          <Grid item>
            <Typography variant="body1">(</Typography>
          </Grid>
          <Grid container item alignItems="center" style={{ width: 'auto' }}>
            <AccountBalanceIcon />
          </Grid>
          {((props.accountType &&
            props.accountType.accountType === AccountType.Res) ||
            (currentPath !== ROUTES.AUTO_PAY &&
              currentPath !== ROUTES.AUTO_PAY_CONFIG)) && (
            <>
              <Grid
                container
                item
                alignItems="center"
                style={{ width: 'auto' }}
              >
                <CreditCardIcon />
              </Grid>
              {types.map(type => (
                <Grid
                  container
                  item
                  alignItems="center"
                  style={{ width: 'auto' }}
                  key={type}
                >
                  <PaymentProfileIcon
                    type={type}
                    style={{ maxWidth: '3em', maxHeight: '1.5em' }}
                  />
                </Grid>
              ))}
            </>
          )}
          <Grid item>
            <Typography variant="body1">)</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
